<template>
  <div class="workorderlist">
    <div class="list">
      <div class="item" v-for="item in workorderlist" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import workorderlist1 from "../../../../assets/product/workorderlist1.png";
import workorderlist2 from "../../../../assets/product/workorderlist2.png";
import workorderlist3 from "../../../../assets/product/workorderlist3.png";
import workorderlist4 from "../../../../assets/product/workorderlist4.png";

export default {
  setup() {
    return reactive({
      workorderlist: [
        {
          id: 1,
          title: "自助服务",
          logo: workorderlist1,
        },
        {
          id: 2,
          title: "智能派单",
          logo: workorderlist2,
        },
        {
          id: 3,
          title: "仓储联动",
          logo: workorderlist3,
        },
        {
          id: 4,
          title: "流程闭环",
          logo: workorderlist4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.workorderlist {
  width: 92vw;
  margin: 24px auto 0;
}
.workorderlist .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.workorderlist .list .item {
    text-align: center;
    overflow: hidden;
}
.workorderlist .list .item img {
    width: 82px;
}
.workorderlist .list .item div {
    margin-top: 8px;
    font-size: 13px;
    font-weight: 600;
}
</style>
